import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainPage from './components/MainPage';
import EdataPresentation from './components/edata/EdataPresentation';

// Empty page component for root path
const EmptyPage: React.FC = () => {
  return (
    <MainPage />
  );
};

function App() {
  return (  
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<EmptyPage />} />
          <Route path="/edata" element={<EdataPresentation />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
